import { n as e, t } from "../../utils-DiFe-_ei.js";
import { Button as n } from "../../foundations/button.js";
import "../../button-C8zrAH2m.js";
import { t as r } from "../../createLucideIcon-CJLgHpqc.js";
import { t as i } from "../../calendar-Bk83OIIY.js";
import { t as a } from "../../check-hnLqiRGn.js";
import { t as o } from "../../chevron-down-D8vOGVnQ.js";
import { n as s, p as c } from "../../navigation-C9BYVgBO.js";
import { a as l, i as u, r as d } from "../../tags-DvdIozRe.js";
import { t as f } from "../../search-Chd7o8f1.js";
import { t as p } from "../../x-DCbCFsrz.js";
import { a as m, i as h, o as g, r as _, s as v, t as y } from "../../calendar-BLyd2Htq.js";
import { Popover as b, PopoverContent as x, PopoverTrigger as S } from "../../foundations/popover.js";
import "../../popover-CcWt3azL.js";
import { Input as C } from "../../foundations/input.js";
import "../../label-Dv91mSbc.js";
import { t as w } from "../../label-DBGQWsW2.js";
import { Typography as T } from "../../foundations/typography.js";
import "../../typography-CTPDhvds.js";
import { a as E, i as D, n as O, o as k, r as A, t as j } from "../../command-Bd6gcY9v.js";
import { t as M } from "../../slider-D1_BcUlF.js";
import { t as ee } from "../../switch-KuhNC7Bx.js";
import { a as N, i as P, n as te, o as ne, r as re } from "../../dist-V_vBpdZH.js";
import * as ie from "react";
import { createContext as ae, useContext as oe, useEffect as F, useId as I, useLayoutEffect as se, useMemo as L, useRef as R, useState as z } from "react";
import { Fragment as ce, jsx as B, jsxs as V } from "react/jsx-runtime";
import { createPortal as le } from "react-dom";
var ue = r("arrow-left", [["path", {
	d: "m12 19-7-7 7-7",
	key: "1l729n"
}], ["path", {
	d: "M19 12H5",
	key: "x3x0zl"
}]]), de = r("globe", [
	["circle", {
		cx: "12",
		cy: "12",
		r: "10",
		key: "1mglay"
	}],
	["path", {
		d: "M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20",
		key: "13o1zl"
	}],
	["path", {
		d: "M2 12h20",
		key: "9i4pu4"
	}]
]), fe = r("minus", [["path", {
	d: "M5 12h14",
	key: "1ays0h"
}]]), pe = r("upload", [
	["path", {
		d: "M12 3v12",
		key: "1x0j5s"
	}],
	["path", {
		d: "m17 8-5-5-5 5",
		key: "7q97r8"
	}],
	["path", {
		d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4",
		key: "ih7n3h"
	}]
]);
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/parseISO.js
function me(e, t) {
	let n = () => m(t?.in, NaN), r = t?.additionalDigits ?? 2, i = ve(e), a;
	if (i.date) {
		let e = ye(i.date, r);
		a = be(e.restDateString, e.year);
	}
	if (!a || isNaN(+a)) return n();
	let o = +a, s = 0, c;
	if (i.time && (s = xe(i.time), isNaN(s))) return n();
	if (i.timezone) {
		if (c = Se(i.timezone), isNaN(c)) return n();
	} else {
		let e = new Date(o + s), n = h(0, t?.in);
		return n.setFullYear(e.getUTCFullYear(), e.getUTCMonth(), e.getUTCDate()), n.setHours(e.getUTCHours(), e.getUTCMinutes(), e.getUTCSeconds(), e.getUTCMilliseconds()), n;
	}
	return h(o + s + c, t?.in);
}
var H = {
	dateTimeDelimiter: /[T ]/,
	timeZoneDelimiter: /[Z ]/i,
	timezone: /([Z+-].*)$/
}, he = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, ge = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, _e = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function ve(e) {
	let t = {}, n = e.split(H.dateTimeDelimiter), r;
	if (n.length > 2) return t;
	if (/:/.test(n[0]) ? r = n[0] : (t.date = n[0], r = n[1], H.timeZoneDelimiter.test(t.date) && (t.date = e.split(H.timeZoneDelimiter)[0], r = e.substr(t.date.length, e.length))), r) {
		let e = H.timezone.exec(r);
		e ? (t.time = r.replace(e[1], ""), t.timezone = e[1]) : t.time = r;
	}
	return t;
}
function ye(e, t) {
	let n = RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + t) + "})|(\\d{2}|[+-]\\d{" + (2 + t) + "})$)"), r = e.match(n);
	if (!r) return {
		year: NaN,
		restDateString: ""
	};
	let i = r[1] ? parseInt(r[1]) : null, a = r[2] ? parseInt(r[2]) : null;
	return {
		year: a === null ? i : a * 100,
		restDateString: e.slice((r[1] || r[2]).length)
	};
}
function be(e, t) {
	if (t === null) return /* @__PURE__ */ new Date(NaN);
	let n = e.match(he);
	if (!n) return /* @__PURE__ */ new Date(NaN);
	let r = !!n[4], i = U(n[1]), a = U(n[2]) - 1, o = U(n[3]), s = U(n[4]), c = U(n[5]) - 1;
	if (r) return De(t, s, c) ? Ce(t, s, c) : /* @__PURE__ */ new Date(NaN);
	{
		let e = /* @__PURE__ */ new Date(0);
		return !Te(t, a, o) || !Ee(t, i) ? /* @__PURE__ */ new Date(NaN) : (e.setUTCFullYear(t, a, Math.max(i, o)), e);
	}
}
function U(e) {
	return e ? parseInt(e) : 1;
}
function xe(e) {
	let t = e.match(ge);
	if (!t) return NaN;
	let n = W(t[1]), r = W(t[2]), i = W(t[3]);
	return Oe(n, r, i) ? n * g + r * v + i * 1e3 : NaN;
}
function W(e) {
	return e && parseFloat(e.replace(",", ".")) || 0;
}
function Se(e) {
	if (e === "Z") return 0;
	let t = e.match(_e);
	if (!t) return 0;
	let n = t[1] === "+" ? -1 : 1, r = parseInt(t[2]), i = t[3] && parseInt(t[3]) || 0;
	return ke(r, i) ? n * (r * g + i * v) : NaN;
}
function Ce(e, t, n) {
	let r = /* @__PURE__ */ new Date(0);
	r.setUTCFullYear(e, 0, 4);
	let i = r.getUTCDay() || 7, a = (t - 1) * 7 + n + 1 - i;
	return r.setUTCDate(r.getUTCDate() + a), r;
}
var we = [
	31,
	null,
	31,
	30,
	31,
	30,
	31,
	31,
	30,
	31,
	30,
	31
];
function G(e) {
	return e % 400 == 0 || e % 4 == 0 && e % 100 != 0;
}
function Te(e, t, n) {
	return t >= 0 && t <= 11 && n >= 1 && n <= (we[t] || (G(e) ? 29 : 28));
}
function Ee(e, t) {
	return t >= 1 && t <= (G(e) ? 366 : 365);
}
function De(e, t, n) {
	return t >= 1 && t <= 53 && n >= 0 && n <= 6;
}
function Oe(e, t, n) {
	return e === 24 ? t === 0 && n === 0 : n >= 0 && n < 60 && t >= 0 && t < 60 && e >= 0 && e < 25;
}
function ke(e, t) {
	return t >= 0 && t <= 59;
}
//#endregion
//#region src/components/forms/inputs/CsvDropZone/CsvDropZone.tsx
function Ae({ onFile: e, disabled: n = !1, accept: r = ".csv", label: i = "Drag and drop a CSV file here, or click to browse", hint: a = "Accepted format: .csv", ariaLabel: o = "CSV drop zone" }) {
	let s = R(null), [c, l] = z(!1), u = r.split(",").map((e) => e.trim().toLowerCase()).filter((e) => e.startsWith("."));
	function d(t) {
		if (t.preventDefault(), l(!1), n) return;
		let r = t.dataTransfer.files[0], i = r?.name.toLowerCase() ?? "";
		r && u.some((e) => i.endsWith(e)) && e(r);
	}
	function f(t) {
		let n = t.target.files?.[0];
		n && e(n), t.target.value = "";
	}
	return /* @__PURE__ */ V("div", {
		role: "button",
		"aria-label": o,
		"aria-disabled": n,
		tabIndex: n ? -1 : 0,
		onClick: () => !n && s.current?.click(),
		onKeyDown: (e) => {
			!n && (e.key === "Enter" || e.key === " ") && s.current?.click();
		},
		onDragOver: (e) => {
			e.preventDefault(), n || l(!0);
		},
		onDragLeave: () => l(!1),
		onDrop: d,
		className: t("flex cursor-pointer flex-col items-center justify-center gap-3 rounded-lg border-2 border-dashed p-10 text-center transition-colors", c ? "border-primary bg-primary/5" : "border-border", n ? "cursor-not-allowed opacity-50" : "hover:border-primary/60 hover:bg-muted/40"),
		children: [
			/* @__PURE__ */ B(pe, { className: "text-muted-foreground h-8 w-8" }),
			/* @__PURE__ */ V("div", { children: [/* @__PURE__ */ B(T, {
				variant: "body",
				className: "font-medium",
				children: i
			}), /* @__PURE__ */ B(T, {
				variant: "label",
				color: "muted",
				className: "mt-1",
				children: a
			})] }),
			/* @__PURE__ */ B("input", {
				ref: s,
				type: "file",
				accept: r,
				className: "hidden",
				disabled: n,
				onChange: f
			})
		]
	});
}
//#endregion
//#region src/components/forms/inputs/TimezonePicker/timezone-data.ts
function je(e) {
	try {
		let t = /* @__PURE__ */ new Date(), n = (new Intl.DateTimeFormat("en", {
			timeZone: e,
			timeZoneName: "shortOffset"
		}).formatToParts(t).find((e) => e.type === "timeZoneName")?.value ?? "GMT+0").match(/GMT([+-])(\d{1,2})(?::(\d{2}))?/);
		if (!n) return {
			label: "GMT+00:00",
			minutes: 0
		};
		let r = n[1] === "+" ? 1 : -1, i = parseInt(n[2], 10), a = parseInt(n[3] ?? "0", 10);
		return {
			label: `GMT${n[1]}${String(i).padStart(2, "0")}:${String(a).padStart(2, "0")}`,
			minutes: r * (i * 60 + a)
		};
	} catch {
		return {
			label: "GMT+00:00",
			minutes: 0
		};
	}
}
function Me(e) {
	let t = e.split("/"), n = t[0], r = (t.at(-1) ?? e).replace(/_/g, " "), i = re[n] ?? "Atlantic / Other", a = te[e] ?? n.replace(/_/g, " "), { label: o, minutes: s } = je(e);
	return {
		value: e,
		city: r,
		country: a,
		offset: o,
		offsetMinutes: s,
		continent: i
	};
}
function Ne() {
	try {
		return Intl.supportedValuesOf("timeZone");
	} catch {
		return ne;
	}
}
var K = Ne().map(Me), Pe = K.filter((e) => e.value.startsWith("Australia/"));
function Fe(e) {
	let t = new Map(P.map((e) => [e, []]));
	for (let n of e) t.get(n.continent)?.push(n);
	return P.flatMap((e) => {
		let n = t.get(e) ?? [];
		return n.length === 0 ? [] : [{
			label: e,
			items: n.toSorted((e, t) => e.city.localeCompare(t.city))
		}];
	});
}
//#endregion
//#region src/components/forms/inputs/TimezonePicker/TimezonePicker.tsx
function Ie(e, t) {
	let [n, r] = z(e), i = R(void 0);
	return F(() => (i.current = setTimeout(() => r(e), t), () => clearTimeout(i.current)), [e, t]), n;
}
function Le({ value: e, onChange: r, placeholder: i = "Select a timezone…", disabled: o = !1, className: s, options: l = K }) {
	let [u, d] = z(!1), [f, p] = z(""), m = Ie(f, 200), h = L(() => l.find((t) => t.value === e), [l, e]), g = L(() => {
		let e = m.trim().toLowerCase();
		return Fe(e ? l.filter((t) => t.city.toLowerCase().includes(e) || t.country.toLowerCase().includes(e) || t.value.toLowerCase().includes(e) || t.offset.toLowerCase().includes(e) || t.continent.toLowerCase().includes(e)) : l);
	}, [m, l]), _ = g.reduce((e, t) => e + t.items.length, 0);
	return /* @__PURE__ */ V(b, {
		open: u,
		onOpenChange: d,
		children: [/* @__PURE__ */ B(S, {
			asChild: !0,
			children: /* @__PURE__ */ V(n, {
				type: "button",
				variant: "outline",
				role: "combobox",
				"aria-expanded": u,
				"aria-label": "Select timezone",
				disabled: o,
				className: t("h-10 w-full justify-between rounded-md font-normal", s),
				children: [/* @__PURE__ */ V("span", {
					className: "flex min-w-0 items-center gap-2",
					children: [/* @__PURE__ */ B(de, {
						className: "text-muted-foreground h-4 w-4 shrink-0",
						"aria-hidden": "true"
					}), h ? /* @__PURE__ */ V("span", {
						className: "truncate",
						children: [
							h.city,
							",",
							" ",
							/* @__PURE__ */ B("span", {
								className: "text-muted-foreground",
								children: h.country
							}),
							" ",
							/* @__PURE__ */ V("span", {
								className: "text-muted-foreground",
								children: [
									"(",
									h.offset,
									")"
								]
							})
						]
					}) : /* @__PURE__ */ B("span", {
						className: "text-muted-foreground",
						children: i
					})]
				}), /* @__PURE__ */ B(c, {
					className: "ml-2 h-4 w-4 shrink-0 opacity-50",
					"aria-hidden": "true"
				})]
			})
		}), /* @__PURE__ */ B(x, {
			className: "w-[420px] p-0",
			align: "start",
			children: /* @__PURE__ */ V(j, {
				shouldFilter: !1,
				children: [/* @__PURE__ */ B(D, {
					className: "text-base md:text-sm",
					placeholder: "Search by city or country…",
					value: f,
					onValueChange: p
				}), /* @__PURE__ */ V(k, {
					className: "max-h-[300px]",
					children: [_ === 0 && /* @__PURE__ */ V(O, { children: [
						"No timezone found for “",
						f,
						"”."
					] }), g.map((n) => n.items.length === 0 ? null : /* @__PURE__ */ B(A, {
						heading: n.label,
						children: n.items.map((n) => /* @__PURE__ */ V(E, {
							value: n.value,
							onSelect: (e) => {
								r?.(e), d(!1), p("");
							},
							children: [
								/* @__PURE__ */ B(a, {
									className: t("mr-2 h-4 w-4 shrink-0", e === n.value ? "opacity-100" : "opacity-0"),
									"aria-hidden": "true"
								}),
								/* @__PURE__ */ V("span", {
									className: "flex-1 truncate",
									children: [n.city, /* @__PURE__ */ V("span", {
										className: "text-muted-foreground",
										children: [", ", n.country]
									})]
								}),
								/* @__PURE__ */ B("span", {
									className: "text-muted-foreground ml-3 shrink-0 text-xs tabular-nums",
									children: n.offset
								})
							]
						}, n.value))
					}, n.label))]
				})]
			})
		})]
	});
}
//#endregion
//#region src/components/forms/inputs/ColorPicker/ColorPicker.tsx
var Re = /^#[0-9a-fA-F]{6}$/;
function ze({ value: e, onChange: n, previewName: r }) {
	let [i, a] = z(e ?? "");
	function o(e) {
		a(e ?? ""), n(e);
	}
	function s() {
		let e = i.toLowerCase();
		Re.test(e) && (a(e), n(e));
	}
	return /* @__PURE__ */ V("div", {
		className: "flex flex-col items-start gap-3",
		children: [
			/* @__PURE__ */ B(u, {
				name: r ?? "Preview",
				color: e
			}),
			/* @__PURE__ */ V("div", {
				className: "flex flex-wrap gap-2",
				children: [d.map((n) => /* @__PURE__ */ B("button", {
					type: "button",
					"aria-label": n,
					onClick: () => o(n),
					className: t("size-6 rounded-full ring-offset-1 transition-shadow", e === n ? "ring-2 ring-stone-900" : "hover:ring-2 hover:ring-stone-400"),
					style: { backgroundColor: n }
				}, n)), /* @__PURE__ */ B("button", {
					type: "button",
					"aria-label": "No colour",
					onClick: () => o(null),
					className: t("size-6 rounded-full border border-stone-300 bg-stone-100 ring-offset-1 transition-shadow", e === null ? "ring-2 ring-stone-900" : "hover:ring-2 hover:ring-stone-400")
				})]
			}),
			/* @__PURE__ */ B("input", {
				type: "text",
				value: i,
				placeholder: "#000000",
				onChange: (e) => a(e.target.value),
				onBlur: s,
				className: "w-28 rounded-md border px-2 py-1 font-mono text-base md:text-sm",
				"aria-label": "Hex colour"
			})
		]
	});
}
//#endregion
//#region src/components/forms/inputs/PhoneInput/PhoneInput.tsx
var Be = /^[\d\s]*$/;
function q(e) {
	let t = e.toUpperCase(), n = [t.charCodeAt(0), t.charCodeAt(1)].map((e) => 127462 + e - 65);
	return String.fromCodePoint(...n);
}
function Ve({ country: e = "AU", onCountryChange: r, value: i = "", onChange: o, onBlur: s, countries: l = N, placeholder: u = "Phone number", disabled: d = !1, className: f }) {
	let [p, m] = z(!1), h = l.length > 0 ? l : N, g = L(() => h.find((t) => t.code === e) ?? h[0], [h, e]);
	function _(e) {
		let t = e.target.value;
		Be.test(t) && o?.(t);
	}
	return /* @__PURE__ */ V("div", {
		className: t("flex items-stretch", f),
		children: [/* @__PURE__ */ V(b, {
			open: p,
			onOpenChange: m,
			children: [/* @__PURE__ */ B(S, {
				asChild: !0,
				children: /* @__PURE__ */ V(n, {
					type: "button",
					variant: "outline",
					role: "combobox",
					"aria-expanded": p,
					"aria-label": "Select country code",
					disabled: d,
					className: "h-10 shrink-0 gap-1.5 rounded-l-md rounded-r-none border-r-0 px-3 font-normal",
					children: [
						/* @__PURE__ */ B("span", {
							"aria-hidden": "true",
							className: "text-base leading-none",
							children: q(g.code)
						}),
						/* @__PURE__ */ B("span", {
							className: "text-sm",
							children: g.dialCode
						}),
						/* @__PURE__ */ B(c, {
							className: "h-4 w-4 shrink-0 opacity-50",
							"aria-hidden": "true"
						})
					]
				})
			}), /* @__PURE__ */ B(x, {
				className: "w-[260px] p-0",
				align: "start",
				children: /* @__PURE__ */ V(j, { children: [/* @__PURE__ */ B(D, {
					className: "text-base md:text-sm",
					placeholder: "Search country…"
				}), /* @__PURE__ */ V(k, {
					className: "max-h-[300px]",
					children: [/* @__PURE__ */ B(O, { children: "No country found." }), /* @__PURE__ */ B(A, { children: h.map((n) => /* @__PURE__ */ V(E, {
						value: `${n.label} ${n.dialCode} ${n.code}`,
						onSelect: () => {
							r?.(n.code), m(!1);
						},
						children: [
							/* @__PURE__ */ B(a, {
								className: t("mr-2 h-4 w-4 shrink-0", e === n.code ? "opacity-100" : "opacity-0"),
								"aria-hidden": "true"
							}),
							/* @__PURE__ */ B("span", {
								"aria-hidden": "true",
								className: "mr-2 text-base leading-none",
								children: q(n.code)
							}),
							/* @__PURE__ */ B("span", {
								className: "flex-1 truncate",
								children: n.label
							}),
							/* @__PURE__ */ B("span", {
								className: "text-muted-foreground ml-3 shrink-0 text-xs tabular-nums",
								children: n.dialCode
							})
						]
					}, n.code)) })]
				})] })
			})]
		}), /* @__PURE__ */ B(C, {
			type: "tel",
			inputMode: "numeric",
			value: i,
			onChange: _,
			onBlur: s,
			placeholder: u,
			disabled: d,
			"aria-label": "Phone number",
			className: "rounded-l-none"
		})]
	});
}
//#endregion
//#region src/components/forms/inputs/PhoneInput/phone-value.ts
var J = "AU";
function He(e, t = N) {
	let n = (e ?? "").replace(/^\s+/, "");
	if (!n.startsWith("+")) return {
		country: J,
		number: n
	};
	let r = [...t].sort((e, t) => t.dialCode.length - e.dialCode.length).find((e) => n.startsWith(e.dialCode));
	return r ? {
		country: r.code,
		number: n.slice(r.dialCode.length).replace(/^ /, "")
	} : {
		country: J,
		number: n
	};
}
function Ue(e, t, n = N) {
	if (!t.trim()) return "";
	let r = n.find((t) => t.code === e)?.dialCode ?? n[0]?.dialCode ?? "";
	return r ? `${r} ${t}` : t;
}
//#endregion
//#region src/components/forms/inputs/EmailInput/EmailInput.tsx
var Y = ie.forwardRef(({ inputMode: e = "email", autoComplete: t = "email", placeholder: n = "name@example.com", onChange: r, onBlur: i, ...a }, o) => {
	function s(e) {
		let t = e.currentTarget, n = t.value, a = n.trim().toLowerCase();
		a !== n && (t.value = a, r && r(Object.assign({}, e, {
			type: "change",
			target: t,
			currentTarget: t
		}))), i?.(e);
	}
	return /* @__PURE__ */ B(C, {
		ref: o,
		type: "email",
		inputMode: e,
		autoComplete: t,
		placeholder: n,
		onChange: r,
		onBlur: s,
		...a
	});
});
Y.displayName = "EmailInput";
//#endregion
//#region src/components/forms/inputs/QuantitySelector/QuantitySelector.tsx
function We({ id: e, value: r, defaultValue: i, onChange: a, onBlur: o, min: s = 1, max: c = Infinity, step: u = 1, disabled: d = !1, className: f, inputClassName: p, ariaLabel: m = "Quantity", placeholder: h }) {
	let g = r !== void 0, [_, v] = z(i ?? 1), y = g ? r : _, [b, x] = z(Number.isNaN(y) ? "" : String(y)), [S, w] = z(!1), T = R(!1);
	F(() => {
		if (T.current) {
			T.current = !1;
			return;
		}
		x(Number.isNaN(y) ? "" : String(y)), w(!1);
	}, [y]);
	function E(e, t = !0) {
		t && x(Number.isNaN(e) ? "" : String(e)), w(!1), T.current = !0, g || v(e), a?.(e);
	}
	function D(e) {
		E(Math.min(Math.max((Number.isNaN(y) ? s : y) + e * u, s), c));
	}
	function O(e) {
		let t = e.target.value;
		if (x(t), t.trim() === "") {
			w(!0);
			return;
		}
		let n = Number(t);
		Number.isNaN(n) || E(Math.min(Math.max(n, s), c), !1);
	}
	function k() {
		o?.(), x(Number.isNaN(y) ? "" : String(y)), w(!1);
	}
	let A = Number.isNaN(y) ? s : y, j = !d && A > s, M = !d && A < c;
	return /* @__PURE__ */ V("div", {
		className: t("isolate flex items-stretch", f),
		children: [
			/* @__PURE__ */ B(n, {
				type: "button",
				variant: "outline",
				size: "icon",
				disabled: !j,
				"aria-label": "Decrease",
				onClick: () => D(-1),
				className: "rounded-l-md rounded-r-none",
				children: /* @__PURE__ */ B(fe, {
					className: "h-4 w-4",
					"aria-hidden": "true"
				})
			}),
			/* @__PURE__ */ B(C, {
				id: e,
				type: "number",
				inputMode: "decimal",
				min: s,
				max: c === Infinity ? void 0 : c,
				step: u,
				value: b,
				disabled: d,
				onChange: O,
				onBlur: k,
				"aria-label": m,
				placeholder: h,
				className: t("relative z-10 -mx-px w-16 [appearance:textfield] rounded-none text-center focus-visible:z-20 [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none", p)
			}),
			/* @__PURE__ */ B(n, {
				type: "button",
				variant: "outline",
				size: "icon",
				disabled: !M,
				"aria-label": "Increase",
				onClick: () => D(1),
				className: "rounded-l-none rounded-r-md",
				children: /* @__PURE__ */ B(l, {
					className: "h-4 w-4",
					"aria-hidden": "true"
				})
			})
		]
	});
}
//#endregion
//#region src/components/forms/inputs/CurrencyInput/CurrencyInput.tsx
function Ge(e) {
	let { maximumFractionDigits: t } = new Intl.NumberFormat(void 0, {
		style: "currency",
		currency: e
	}).resolvedOptions();
	return t ?? 2;
}
function Ke(e) {
	return e === 0 ? "0" : `0.${"0".repeat(e)}`;
}
function X(e, t) {
	return Number.isNaN(e) ? "" : e.toFixed(t);
}
function qe(e, t) {
	let n = e.replace(/[^0-9.]/g, ""), r = n.indexOf(".");
	if (r !== -1 && (n = n.slice(0, r + 1) + n.slice(r + 1).replace(/\./g, "")), t === 0) n = r === -1 ? n : n.slice(0, r);
	else if (r !== -1) {
		let [e, r] = n.split(".");
		n = `${e}.${r.slice(0, t)}`;
	}
	return n;
}
function Je({ id: e, value: n, defaultValue: r, onChange: i, onBlur: a, currency: o, min: s = 0, disabled: c = !1, className: l, ariaLabel: u = "Amount" }) {
	let d = n !== void 0, [f, p] = z(r ?? 0), m = d ? n : f, h = Ge(o), [g, _] = z(X(m, h)), [, v] = z(!1), y = R(null);
	F(() => {
		let e = y.current;
		if (e && e.value === m && e.fractionDigits === h) {
			y.current = null;
			return;
		}
		_(X(m, h)), v(!1);
	}, [m, h]);
	function b(e, t = !0) {
		t && _(e.toFixed(h)), v(!1), y.current = {
			value: e,
			fractionDigits: h
		}, d || p(e), i?.(e);
	}
	function x(e) {
		let t = qe(e, h);
		if (_(t), t === "" || t === ".") {
			v(!0);
			return;
		}
		let n = Number(t);
		Number.isNaN(n) || b(Math.max(n, s), !1);
	}
	function S(e) {
		x(e.target.value);
	}
	function w(e) {
		e.preventDefault(), x(e.clipboardData.getData("text"));
	}
	function T() {
		a?.();
		let e = Number.isNaN(m) ? s : Math.max(m, s);
		_(e.toFixed(h)), v(!1), e !== m && b(e);
	}
	return /* @__PURE__ */ V("div", {
		className: t("flex items-stretch", l),
		children: [/* @__PURE__ */ B(C, {
			id: e,
			type: "text",
			inputMode: "decimal",
			value: g,
			disabled: c,
			onChange: S,
			onPaste: w,
			onBlur: T,
			placeholder: Ke(h),
			"aria-label": u,
			className: "relative z-10 -mr-px rounded-r-none focus-visible:z-20"
		}), /* @__PURE__ */ B("span", {
			className: "bg-muted text-foreground border-input flex shrink-0 items-center rounded-r-md border px-3 text-sm font-medium",
			children: o
		})]
	});
}
//#endregion
//#region src/components/forms/inputs/PercentageSplitInput/PercentageSplitInput.tsx
function Ye(e) {
	return Math.min(99, Math.max(1, Math.round(e)));
}
function Z(e) {
	if (e.length === 0) return e;
	let t = e.map((e) => Math.max(1, Math.min(99, Math.round(e)))), n = 100 - t.reduce((e, t) => e + t, 0);
	for (; n !== 0;) {
		let e = n > 0 ? 1 : -1, r = t.findIndex((t) => e > 0 ? t < 99 : t > 1);
		if (r === -1) break;
		t[r] += e, n -= e;
	}
	return t;
}
function Xe(e, t, n) {
	let r = Ye(n), i = r - e[t];
	if (i === 0) return e;
	let a = e.map((e, t) => t).filter((e) => e !== t), o = a.reduce((t, n) => t + e[n], 0);
	if (o <= 0) return e;
	let s = [...e];
	s[t] = r;
	let c = -i, l = 0;
	return a.forEach((t, n) => {
		let r = n === a.length - 1 ? c - l : Math.round(e[t] / o * c), i = Math.max(1, e[t] + r);
		l += i - e[t], s[t] = i;
	}), Z(s);
}
function Ze(e) {
	let t = e.indexOf(Math.max(...e)), n = e[t], r = Math.max(1, Math.ceil(n / 2)), i = Math.max(1, n - r), a = [...e];
	return a[t] = r, a.splice(t + 1, 0, i), Z(a);
}
function Qe(e, t) {
	let n = e[t], r = e.map((e, t) => t).filter((e) => e !== t), i = r.reduce((t, n) => t + e[n], 0), a = e.filter((e, n) => n !== t);
	if (i <= 0) return Z(a);
	let o = 0;
	return r.forEach((s, c) => {
		let l = s < t ? s : s - 1, u = c === r.length - 1 ? n - o : Math.round(e[s] / i * n), d = Math.max(1, e[s] + u);
		o += d - e[s], a[l] = d;
	}), Z(a);
}
function Q({ value: e, onChange: t, onAdd: n, onRemove: r, min: i = 2, max: a = 5, disabled: o = !1 }) {
	let s = e.reduce((e, t) => e + t, 0), c = !o && e.length > i, l = !o && e.length < a;
	function u(n, r) {
		t(Xe(e, n, r));
	}
	function d() {
		let r = e.indexOf(Math.max(...e)) + 1;
		t(Ze(e)), n?.(r);
	}
	function f(n) {
		t(Qe(e, n)), r?.(n);
	}
	return {
		total: s,
		canAdd: l,
		canRemove: c,
		handleDrag: u,
		handleAdd: d,
		handleRemove: f
	};
}
function $e({ value: e, onChange: r, onAdd: i, onRemove: a, min: o = 2, max: s = 5, disabled: c = !1, labels: u, showTotal: d = !0, className: f }) {
	let { total: m, canAdd: h, canRemove: g, handleDrag: _, handleAdd: v, handleRemove: y } = Q({
		value: e,
		onChange: r,
		onAdd: i,
		onRemove: a,
		min: o,
		max: s,
		disabled: c
	});
	return /* @__PURE__ */ V("div", {
		className: t("flex flex-col gap-3", f),
		children: [e.map((e, t) => /* @__PURE__ */ V("div", {
			className: "space-y-1.5",
			children: [u?.[t] && /* @__PURE__ */ B("span", {
				className: "text-sm font-medium",
				children: u[t]
			}), /* @__PURE__ */ V("div", {
				className: "flex items-center gap-3",
				children: [
					/* @__PURE__ */ B(M, {
						value: [e],
						min: 1,
						max: 99,
						step: 1,
						disabled: c,
						onValueChange: ([e]) => _(t, e),
						"aria-label": `Split ${t + 1} percentage`,
						className: "flex-1"
					}),
					/* @__PURE__ */ V("span", {
						className: "w-12 text-right text-sm tabular-nums",
						children: [e, "%"]
					}),
					/* @__PURE__ */ B(n, {
						type: "button",
						variant: "ghost",
						size: "icon",
						disabled: !g,
						"aria-label": `Remove split ${t + 1}`,
						onClick: () => y(t),
						children: /* @__PURE__ */ B(p, {
							className: "h-4 w-4",
							"aria-hidden": "true"
						})
					})
				]
			})]
		}, t)), /* @__PURE__ */ V("div", {
			className: "flex items-center justify-between",
			children: [/* @__PURE__ */ V(n, {
				type: "button",
				variant: "outline",
				size: "sm",
				disabled: !h,
				onClick: v,
				children: [/* @__PURE__ */ B(l, {
					className: "h-4 w-4",
					"aria-hidden": "true"
				}), "Add split"]
			}), d && /* @__PURE__ */ V("span", {
				role: "status",
				className: "text-muted-foreground text-sm",
				children: [
					"Total: ",
					m,
					"%"
				]
			})]
		})]
	});
}
//#endregion
//#region src/components/forms/inputs/DatePicker/DatePicker.tsx
function et({ id: e, value: r, onChange: a, placeholder: o = "Pick a date", disabled: s = !1, required: c = !1, className: l }) {
	let [u, d] = z(!1), f = r ? me(r) : void 0;
	return /* @__PURE__ */ V(b, {
		open: u,
		onOpenChange: d,
		children: [/* @__PURE__ */ B(S, {
			asChild: !0,
			children: /* @__PURE__ */ V(n, {
				id: e,
				type: "button",
				variant: "outline",
				disabled: s,
				className: t("w-full justify-start rounded-lg text-left text-base font-normal md:text-sm", !f && "text-muted-foreground", l),
				children: [/* @__PURE__ */ B(i, { className: "mr-2 h-4 w-4" }), f ? _(f, "PPP") : o]
			})
		}), /* @__PURE__ */ B(x, {
			className: "w-auto p-0",
			align: "start",
			children: c ? /* @__PURE__ */ B(y, {
				mode: "single",
				required: !0,
				selected: f,
				defaultMonth: f,
				onSelect: (e) => {
					a(_(e, "yyyy-MM-dd")), d(!1);
				}
			}) : /* @__PURE__ */ B(y, {
				mode: "single",
				selected: f,
				defaultMonth: f,
				onSelect: (e) => {
					a(e ? _(e, "yyyy-MM-dd") : ""), d(!1);
				}
			})
		})]
	});
}
//#endregion
//#region src/components/forms/inputs/SearchInput/SearchInput.tsx
function tt({ className: e, ...n }) {
	return /* @__PURE__ */ V("div", {
		className: "relative",
		children: [/* @__PURE__ */ B(f, { className: "text-muted-foreground absolute top-1/2 left-3 h-4 w-4 -translate-y-1/2" }), /* @__PURE__ */ B(C, {
			type: "search",
			className: t("pl-9", e),
			...n
		})]
	});
}
//#endregion
//#region src/components/forms/layout/FormFooter/FormFooterSlot.ts
var $ = ae(void 0);
//#endregion
//#region src/components/forms/layout/FormFooter/FormFooter.tsx
function nt({ statusText: e, actions: t }) {
	let r = oe($), i = R(null), a = I(), [o, s] = z();
	se(() => {
		let e = i.current?.closest("form");
		e && (e.id ||= a, s(e.id));
	}, [a]);
	let c = /* @__PURE__ */ V("div", {
		className: "bg-background/92 flex flex-wrap items-center justify-between gap-2 py-4 backdrop-blur-sm md:sticky md:bottom-0 md:border-t",
		children: [/* @__PURE__ */ B(T, {
			variant: "body-sm",
			color: "muted",
			as: "span",
			children: e
		}), /* @__PURE__ */ B("div", {
			className: "flex items-center gap-2",
			children: t.map((e) => /* @__PURE__ */ V(n, {
				type: e.type ?? "button",
				variant: e.variant ?? "default",
				onClick: e.onClick,
				disabled: e.disabled,
				form: r ? o : void 0,
				children: [e.icon, e.label]
			}, e.label))
		})]
	});
	return r === void 0 ? c : /* @__PURE__ */ V(ce, { children: [/* @__PURE__ */ B("span", {
		ref: i,
		hidden: !0
	}), r && o ? le(c, r) : null] });
}
//#endregion
//#region src/components/forms/layout/FormPageHeader/FormPageHeader.tsx
function rt({ backTo: t, backLabel: n, eyebrow: r, title: i, subtitle: a, linkComponent: o = "a" }) {
	return /* @__PURE__ */ V("div", { children: [/* @__PURE__ */ V(o, {
		...e(o, t),
		className: "text-muted-foreground hover:text-foreground mb-6 inline-flex items-center gap-1.5 text-sm",
		children: [/* @__PURE__ */ B(ue, { className: "h-4 w-4" }), n]
	}), /* @__PURE__ */ V("div", {
		className: "mb-8",
		children: [
			r && /* @__PURE__ */ B(T, {
				variant: "overline",
				color: "muted",
				children: r
			}),
			/* @__PURE__ */ B(T, {
				variant: "display-lg",
				as: "h1",
				className: r ? "mt-1.5" : void 0,
				children: i
			}),
			a && /* @__PURE__ */ B(T, {
				variant: "body",
				color: "muted",
				className: "mt-2",
				children: a
			})
		]
	})] });
}
//#endregion
//#region src/components/forms/layout/FormPageLayout/FormPageLayout.tsx
function it({ children: e, header: n, sidebar: r, maxWidth: i = "narrow" }) {
	let [a, o] = z(null);
	return /* @__PURE__ */ V("div", {
		className: t("mx-auto p-8", i === "wide" ? "max-w-[1100px]" : "max-w-3xl"),
		children: [n, r ? /* @__PURE__ */ V($, {
			value: a,
			children: [/* @__PURE__ */ B(s, {
				aside: /* @__PURE__ */ B("div", {
					className: "space-y-4",
					children: r
				}),
				storageKey: "form-page-aside-collapsed",
				asideLabel: "summary",
				isAsideSticky: !0,
				children: e
			}), /* @__PURE__ */ B("div", {
				ref: o,
				className: "contents"
			})]
		}) : /* @__PURE__ */ B("div", {
			className: "@container",
			children: e
		})]
	});
}
//#endregion
//#region src/components/forms/layout/FormSection/FormSection.tsx
function at({ title: e, icon: n, description: r, action: i, collapsible: a = !1, defaultOpen: s = !0, toggle: c, children: l }) {
	let [u, d] = z(s), f = I(), p = (!a || u) && (!c || c.checked), m = `${f}-toggle`, h = /* @__PURE__ */ V("div", { children: [/* @__PURE__ */ V("div", {
		className: "flex items-center gap-1.5",
		children: [n && /* @__PURE__ */ B(n, {
			className: "size-4",
			"aria-hidden": "true"
		}), /* @__PURE__ */ B(T, {
			variant: "h5",
			as: "h3",
			children: e
		})]
	}), r && /* @__PURE__ */ B(T, {
		variant: "body-sm",
		color: "muted",
		className: "mt-1",
		children: r
	})] });
	return /* @__PURE__ */ V("div", {
		className: "bg-card rounded-xl border shadow-sm",
		children: [/* @__PURE__ */ V("div", {
			className: t("flex items-start justify-between gap-4 px-6 py-4", p && "border-b"),
			children: [
				a ? /* @__PURE__ */ V("button", {
					type: "button",
					"aria-expanded": p,
					"aria-controls": f,
					onClick: () => d((e) => !e),
					className: "group focus-visible:ring-ring -m-1 flex flex-1 cursor-pointer items-start justify-between gap-2 rounded-md p-1 text-left focus-visible:ring-2 focus-visible:outline-none",
					children: [h, /* @__PURE__ */ B("span", {
						className: "text-muted-foreground group-hover:bg-muted group-hover:text-foreground flex size-7 shrink-0 items-center justify-center rounded-md transition-colors",
						children: /* @__PURE__ */ B(o, {
							className: t("size-4 transition-transform", p && "rotate-180"),
							"aria-hidden": "true"
						})
					})]
				}) : h,
				i,
				c && /* @__PURE__ */ V("div", {
					className: "flex shrink-0 items-center gap-2",
					children: [/* @__PURE__ */ B(w, {
						htmlFor: m,
						children: c.label
					}), /* @__PURE__ */ B(ee, {
						id: m,
						checked: c.checked,
						onCheckedChange: c.onCheckedChange
					})]
				})
			]
		}), /* @__PURE__ */ B("div", {
			id: f,
			hidden: !p,
			className: "space-y-4 px-6 py-5",
			children: l
		})]
	});
}
//#endregion
export { K as ALL_TIMEZONE_OPTIONS, Pe as AU_ONLY_TIMEZONE_OPTIONS, ze as ColorPicker, Ae as CsvDropZone, Je as CurrencyInput, et as DatePicker, Y as EmailInput, nt as FormFooter, rt as FormPageHeader, it as FormPageLayout, at as FormSection, $e as PercentageSplitInput, Ve as PhoneInput, We as QuantitySelector, tt as SearchInput, Le as TimezoneSelect, Ue as formatPhoneValue, He as parsePhoneValue, Q as usePercentageSplitRows };

//# sourceMappingURL=index.js.map